import script from "./AnnualReport.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnualReport.vue?vue&type=script&setup=true&lang=js"

import "./AnnualReport.vue?vue&type=style&index=0&id=6bf85c95&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bf85c95"]])

export default __exports__